import gql from 'graphql-tag';

export const mutationDeleteCredential = gql`
  mutation deleteCredential (
    $id: DokkioID!
  ) {
    deleteCredential (
      id: $id
    )
  }
`;
export default mutationDeleteCredential;
